module.exports = __webpack_public_path__ + "img/l6.bd99e828.jpg";